export default __webpack_public_path__ + "static/media/chevrons_right.7173076f.svg";